define(
    'modals/secured/account/CancelTrialModal',[
        "plugins/dialog",
        "services/session",
        "i19n!i19n/strings"
    ],
    function (dialog, session, i19n) {
        function Modal() {
            var self = this;

            self.i19n = i19n;
            self.password =  ko.observable('');
        }

        Modal.prototype.activate = function () { };
        
        Modal.prototype.cancelTrial = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                var self = this;

                session.login(session.user().emailAddress(), this.password(), false)
                .done(function (d) {
                    if(d)
                        dialog.close(self, { cancelTrial: true });
                    else
                        dialog.close(self, { close: true });
                })
                .fail(function (e) {
                    dialog.close(self, { close: true });

                    console.error(e);
                })
                .always(function () {
                    complete();
                });
            }
        });
        Modal.prototype.close = function () {
            var self = this;

            dialog.close(self, { close: true });
        };

        return Modal;
    }
);
